import { render, staticRenderFns } from "./GamesWithGenresMultiSelect.vue?vue&type=template&id=e1785152&"
import script from "./GamesWithGenresMultiSelect.vue?vue&type=script&lang=js&"
export * from "./GamesWithGenresMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./GamesWithGenresMultiSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports